import { Link } from "react-router"
import { ArrowUpRight } from "../layout"

export function BottomCta() {
  return (
    <section className="bg-cream-50 pb-24 lg:pb-[153px]">
      <div className="public-container">
        <div className="relative min-h-[500px] overflow-hidden rounded-[32px] bg-forest-700">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_20%_35%,rgba(110,170,133,0.35),transparent_42%),radial-gradient(ellipse_at_80%_72%,rgba(5,50,35,0.7),transparent_48%)]" />
          <div className="absolute -bottom-48 left-[-12%] h-[380px] w-[70%] rotate-[-12deg] rounded-[50%] bg-forest-800/80" />
          <div className="absolute -bottom-56 right-[-8%] h-[430px] w-[75%] rotate-[10deg] rounded-[50%] bg-forest-950/70" />

          <div className="relative mx-auto flex min-h-[500px] max-w-2xl flex-col items-center justify-center px-8 py-20 text-center">
            <h2 className="font-display text-[36px] font-bold leading-tight text-white sm:text-[64px] sm:leading-none">
              Change a life.<br /><span className="text-gold-500">Fund a dream.</span>
            </h2>
            <p className="mx-auto mt-6 max-w-xl text-lg text-cream-50">
              Your sponsorship can turn dreams into reality and pave the way for a brighter future. Fund a dream today!
            </p>
            <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
              <Link to="/sponsor" className="inline-flex items-center gap-3 rounded-full bg-gold-500 py-1.5 pl-5 pr-1.5 text-lg font-semibold text-ink transition-colors hover:bg-gold-400">
                Sponsor a Child
                <span className="grid h-10 w-10 place-items-center rounded-full bg-forest-950 text-white">
                  <ArrowUpRight />
                </span>
              </Link>
              <Link to="/partner-schools" className="inline-flex items-center gap-3 rounded-full bg-forest-950 py-1.5 pl-5 pr-1.5 text-lg font-semibold text-white transition-colors hover:bg-forest-800">
                Partner with us
                <span className="grid h-10 w-10 place-items-center rounded-full bg-white text-forest-950">
                  <ArrowUpRight />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
